import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { IUsuarioFormulario } from 'src/integracoes/modelos/usuarios';
import { FarmaError } from 'src/integracoes/modelos/erros';
import { atribuiEmpresasUsuario, atualizarUsuario, criarUsuario, deletarUsuario, enviaEmailAtivacao, obtemUsuarios } from 'src/integracoes/servicos/mongo-atlas/funcoes/usuarios';
import {
  removeUsuarioFirebase
} from '../../integracoes/servicos/firebase/functions';
import {
  USERS_FETCH_DATA_INIT,
  USERS_CREATE_USER_INIT,
  USERS_DELETE_USER_INIT,
  USERS_MODIFY_USER_INIT,
  ATRIBUIR_EMPRESA_INIT,
  USER_SEND_EMAIL_INIT
} from '../actionTypes';
import {
  usersFetchDataSuccess,
  usersCreateUserSuccess,
  usersDeleteUserSuccess,
  usersModifyUserSuccess,
  atribuirEmpresaSuccess,
  userErrorMsg,
  userSendEmailSuccess
} from './actions';
import { IUsuarioMongoDB } from 'src/integracoes/modelos/usuarios';

interface FetchListaUsuariosResult {
  isError: boolean;
  usuariosMongo: IUsuarioMongoDB[];
  msg: string;
}

// ---------------Busca lista Usuários por empresa --------------------------------------------

const fetchListarUsuarios = async (empId: string): Promise<FetchListaUsuariosResult> => {
  try {

    const { status, dados, mensagem } = await obtemUsuarios(empId);

    // Validando respostas
    if (status &&
      Array.isArray(dados)
    ) {
      return {
        isError: false,
        usuariosMongo: dados,
        msg: mensagem
      };
    }

    // Se a chamada falhar ou os dados não forem array, retorna um erro
    return {
      isError: true,
      usuariosMongo: [],
      msg: mensagem
    };
  } catch (error: any) {
    throw new FarmaError(error);
  }
};

export function* parseListaUsuarios({ payload }: { payload: any, type: any }) {
  const { empId } = payload;
  try {
    const usersData: FetchListaUsuariosResult = yield call(fetchListarUsuarios, empId);
    if (!usersData.isError) {
      yield put(usersFetchDataSuccess(usersData));
    } else {
      yield put(userErrorMsg({ msg: usersData.msg }));
    }
  } catch (error: any) {
    yield put(userErrorMsg({ msg: error.mensagem ? `${error.mensagem}` : `${error.message}` }));
  }
}

export function* watchListaUsuarios() {
  yield takeEvery(USERS_FETCH_DATA_INIT, parseListaUsuarios);
}


// ----------------Cria um Usuário-------------------------------------------

export const fetchCriarUsuario = async (usuario: IUsuarioMongoDB) => {
  try {
    const { status, dados, mensagem } = await criarUsuario(usuario);
    if (status) {
      return {
        isCreated: true,
        msg: mensagem,
        data: dados
      };
    } else {
      return { isCreated: false, msg: mensagem, data: null };
    }
  } catch (error: any) {
    throw new FarmaError(error);
  }
};

function* parseCriaUsuario({ payload }: { payload: any; type: string }) {
  const { usuario } = payload;
  try {
    const { isCreated, msg, data } = yield call(fetchCriarUsuario, usuario);
    if (isCreated) {
      yield put(
        usersCreateUserSuccess({
          msg: msg,
          userData: data,
        })
      );
    } else {
      yield put(userErrorMsg({ msg: msg }));
    }
  } catch (error: any) {
    yield put(userErrorMsg({ msg: error.mensagem ? `${error.mensagem}` : `${error.message}` }));
  }
}

export function* watchCriarUsuario() {
  yield takeEvery(USERS_CREATE_USER_INIT, parseCriaUsuario);
}

// ---------------------Atualizar Usuário--------------------------------------------------

export const fetchAtualizarUsuario = async (id: string, usuario: any) => {

  try {
    const { mensagem, status, dados } = await atualizarUsuario(id, usuario);
    if (status) {
      return {
        isUpdated: true,
        msg: mensagem,
        data: dados
      };
    } else {
      return { isUpdated: false, msg: mensagem, data: null };
    }
  } catch (error: any) {
    throw new FarmaError(error);
  }
};

function* parseAtualizaUsuario({ payload }: { payload: any; type: string }) {
  const { id, user } = payload;
  try {
    const { msg, isUpdated } = yield call(fetchAtualizarUsuario, id, user);
    if (isUpdated) {
      yield put(usersModifyUserSuccess({ msg }));
    } else {
      yield put(userErrorMsg({ msg }));
    }
  } catch (error: any) {
    yield put(userErrorMsg({ msg: error.mensagem ? `${error.mensagem}` : `${error.message}` }));
  }
}
export function* watchAtualizaUsuario() {
  yield takeEvery(USERS_MODIFY_USER_INIT, parseAtualizaUsuario);
}

// ----------------Deleta Usuário------------------------------------------
export const fetchDeletaUsuario = async (id: string, email: string) => {
  try {
    // Primeiro remove do Firebase
    await removeUsuarioFirebase(email);
    // Se a remoção do Firebase foi bem-sucedida, remove do Mongo
    const { status, mensagem } = await deletarUsuario(id);
    return { msg: mensagem, status };
  } catch (error: any) {
    throw new FarmaError(error);
  }
};

function* parseDeletaUsuario({ payload }: { payload: any; type: any }) {
  const { id, email } = payload;
  try {
    const { status, msg } = yield call(fetchDeletaUsuario, id, email);
    if (status) {
      yield put(usersDeleteUserSuccess({ id, msg }));
    } else {
      yield put(userErrorMsg({ msg }));
    }
  } catch (error: any) {
    yield put(userErrorMsg({ msg: error.mensagem ? `${error.mensagem}` : `${error.message}` }));
  }
}

export function* watchDeletaUsuario() {
  yield takeEvery(USERS_DELETE_USER_INIT, parseDeletaUsuario);
}

// ---------------------Atribuir empresas Usuário--------------------------------------------------
const fetchAtribuiEmpresasUsuario = async (id: string, empresas: any) => {
  try {
    const { status, dados, mensagem } = await atribuiEmpresasUsuario(
      id,
      empresas
    );
    if (status) {
      return {
        isUpdated: true,
        msg: mensagem,
        data: dados
      };
    } else {
      return { isUpdated: false, msg: mensagem, data: null };
    }
  }
  catch (error: any) {
    throw new FarmaError(error);
  }
};

function* parseAtribuiEmpresasUsuario({ payload }: { payload: any, type: any }) {
  const { id, empresas } = payload;
  try {
    const { isUpdated, msg } = yield call(fetchAtribuiEmpresasUsuario, id, empresas);

    if (isUpdated) {
      yield put(atribuirEmpresaSuccess({ msg }));
    } else {
      yield put(userErrorMsg({ msg }));
    }
  } catch (error: any) {
    yield put(userErrorMsg({ msg: error.mensagem ? `${error.mensagem}` : `${error.message}` }));
  }
}

export function* watchAtribuEmpresasUsuario() {
  yield takeEvery(ATRIBUIR_EMPRESA_INIT, parseAtribuiEmpresasUsuario);
}

// ----------------Envia Email Usuário------------------------------------------
export const SendEmailUsuario = async (payload: IUsuarioFormulario) => {
  try {
    const { status, mensagem } = await enviaEmailAtivacao(
      payload
    );
    return { msg: mensagem, status };
  } catch (error: any) {
    throw new FarmaError(error);
  }
};

function* parseSendEmailUsuario({ payload }: { payload: any, type: any }) {
  try {
    const { status, msg } = yield call(SendEmailUsuario, payload);
    if (status) {
      yield put(userSendEmailSuccess({ msg }));
    } else {
      yield put(userErrorMsg({ msg }));
    }
  } catch (error: any) {
    yield put(userErrorMsg({ msg: error.mensagem ? `${error.mensagem}` : `${error.message}` }));
  }
}

export function* watchSendEmailUsuario() {
  yield takeEvery(USER_SEND_EMAIL_INIT, parseSendEmailUsuario);
}

//-----------------------------------------------------------------------
export default function* rootSaga() {
  yield all([
    fork(watchListaUsuarios),
    fork(watchCriarUsuario),
    fork(watchDeletaUsuario),
    fork(watchAtualizaUsuario),
    fork(watchAtribuEmpresasUsuario),
    fork(watchSendEmailUsuario),
  ]);
}
